const styles = (theme) => ({
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(1, 3),
  },
  searchFieldsAll: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  searchContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  joinedSearchAll: {
    display: "flex",
    alignItems: "center",
  },
  calendarPopover: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
  },
  label: {
    marginRight: theme.spacing(1),
    alignItems: "center",
    fontSize: "1rem",
    fontWeight: 600,
  },
  downloadButton: {
    marginLeft: theme.spacing(2),
  },
  grow: {
    flexGrow: 1,
  },
  select: {
    marginRight: theme.spacing(2),
    minWidth: 120,
  },
  searchInput: {
    marginRight: theme.spacing(1),
    width: 300,
  },
  menuItem: {
    fontSize: "0.9rem",
  },
  tableWrapper: {
    overflowX: "auto",
  },
  tableHeaderCell: {
    fontWeight: 600,
    backgroundColor: "#f8fafc",
    color: "#475569",
  },
  candidateBadge: {
    backgroundColor: "#ecfdf5",
    color: "#047857",
    border: "1px solid #a7f3d0",
    fontWeight: 600,
    fontSize: "12px",
  },
  companyBadge: {
    backgroundColor: "#f5f3ff",
    color: "#6d28d9",
    border: "1px solid #ddd6fe",
    fontWeight: 600,
    fontSize: "12px",
  },
  defaultBadge: {
    backgroundColor: "#eff6ff",
    color: "#1d4ed8",
    border: "1px solid #bfdbfe",
    fontWeight: 600,
    fontSize: "12px",
  },
});

export default styles;
